var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#008B44"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3229_3073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7H25.5V25H7.5V7Z",
    fill: "#008B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.25V10.75H12V13.75C12 15.4075 13.3425 16.75 15 16.75C16.6575 16.75 18 15.4075 18 13.75V10.75H16.5V9.25H18.75C19.164 9.25 19.5 9.586 19.5 10V13.75C19.5 15.9798 17.8785 17.83 15.75 18.1877V19.375C15.75 20.8247 16.9253 22 18.375 22C19.4978 22 20.4562 21.295 20.8312 20.3027C20.046 19.9525 19.5 19.165 19.5 18.25C19.5 17.0072 20.5072 16 21.75 16C22.9928 16 24 17.0072 24 18.25C24 19.2782 23.31 20.1453 22.368 20.4137C21.9075 22.189 20.2943 23.5 18.375 23.5C16.0965 23.5 14.25 21.6535 14.25 19.375V18.1877C12.1215 17.8307 10.5 15.9798 10.5 13.75V10C10.5 9.586 10.836 9.25 11.25 9.25H13.5ZM21.75 17.5C21.336 17.5 21 17.836 21 18.25C21 18.664 21.336 19 21.75 19C22.164 19 22.5 18.664 22.5 18.25C22.5 17.836 22.164 17.5 21.75 17.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3229_3073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7.5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDoctor);
export default __webpack_public_path__ + "static/media/totalDoctor.767ba5e81e32cb8651736c90ceba10f4.svg";
export { ForwardRef as ReactComponent };